<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Create a tab on a profile page that can be loaded separately
    *
    * @since 20220209
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2022 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div>
        <div v-if="hasLoaded">
            <slot name="profile_page" v-bind:data="data" v-bind:profilePage="profilePage"></slot>
            <button type="button" class="btn btn-outline-dark float-right" @click="getData(true)">Refresh Tab <i class="fas fa-sync"></i></button>     
        </div>
        <div v-else class="p-3">
            Loading tab <i class="fa fa-sync fa-spin fa-lg"></i> <a v-if="!loading" href="#" onclick="return false" @click="getData(true)">If the tab isn't loading, click here to load it.</a>
        </div>
    </div>
</template>

<script>
    import loadcomponents from './loadcomponents'
    export default{
        props: {
            //the forms to display
            getRoute: {
                type: String,
                default: ''
            },
            //the forms to display
            loaded: {
                type: Boolean,
                default: false
            },
            //js scripts to load
            scriptsToLoad: {
                type: Array
            },
            initialData: {
                type: Object|Array
            }
        },
        //loads after components have loaded
        mounted() {
            if(this.loaded){
                var self = this;
                loadcomponents.loadComponents(this.scriptsToLoad, function(){
                    self.hasLoaded = true;
                });
            }
        },
        data() {
            return {
                data: this.initialData,
                hasLoaded: false,
                loading: false,
                profilePage: this
            }
        },
        computed: {

        },
        methods: {
           /**
            * gets the data for the tab
            */
            getData: async function (refresh = false, extraParams=null) {
                if((!this.hasLoaded || refresh) && !this.loading){
                    this.loading = true;
                    if(refresh){
                        this.hasLoaded = false;
                    }
                    try {
                        var route = this.getRoute;
                        if(extraParams !== null){
                            for (const key in extraParams) {
                                if (extraParams.hasOwnProperty(key)) {
                                    route = route + '&' + key + '=' + extraParams[key];
                                }
                            }
                        }
                        if(refresh){
                            route = route + '&refresh=1';
                        }
                        const { data } = await this.$http.get(route);
                        
                        if(data.error !== undefined){
                            console.log('An error occurred getting the data');
                            console.log(data.error);
                        } else if(data !== undefined){
                            this.data = data;
                            var self = this;
                            loadcomponents.loadComponents(this.scriptsToLoad, function(){
                                self.hasLoaded = true;
                            });
                        } else {
                            console.log(data);
                        }
                    } catch(error) {
                        console.log('An error occurred getting the data');
                        if(error.response !== undefined){
                            console.log('File: ' + error.response.data.file);
                            console.log('Line: ' + error.response.data.line);
                            console.log('Message: ' + error.response.data.message);
                            console.log('Exception: ' + error.response.data.exception);
                            console.log(error.response.data.trace);
                        } else {
                            console.log(error);
                        }
                    }
                    this.loading = false;
                }
            },
        }
    }
</script>